import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GbSetupTutorialVideosComponent } from './gb-setup-tutorial-videos/gb-setup-tutorial-videos.component'
import { GbStaffAnnouncementsComponent } from './gb-staff-announcements/gb-staff-announcements.component'
import { GbStaffReportsComponent } from './gb-staff-reports/gb-staff-reports.component'
import { GbStaffComponent } from './gb-staff/gb-staff.component'
import { StaffConstants } from './staff.constants'
import { GbAwsToolsComponent } from './gb-aws-tools/gb-aws-tools.component'
import { GbUserAccountsComponent } from './gb-user-accounts/gb-user-accounts.component'
import { StaffSuGuard } from 'libs/gb-dashboard/account/utils/src/lib/gb-staff-su-guard/gb-staff-su.guard'

export const routes: Routes = [
  {
    path: '',
    component: GbStaffComponent,
    children: [
      {
        path: StaffConstants.ANNOUNCEMENTS,
        component: GbStaffAnnouncementsComponent,
        canActivate: [StaffSuGuard],
      },
      {
        path: StaffConstants.REPORTS,
        component: GbStaffReportsComponent,
        canActivate: [StaffSuGuard],
      },
      {
        path: StaffConstants.TUTORIAL_VIDEOS,
        component: GbSetupTutorialVideosComponent,
        canActivate: [StaffSuGuard],
      },
      {
        path: StaffConstants.AWS,
        component: GbAwsToolsComponent,
        canActivate: [StaffSuGuard],
      },
      {
        path: StaffConstants.USER_ACCOUNTS,
        component: GbUserAccountsComponent,
      },
      {
        path: '',
        redirectTo: StaffConstants.USER_ACCOUNTS,
        pathMatch: 'full',
      },
      {
        path: '**',
        redirectTo: StaffConstants.USER_ACCOUNTS,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GbDashboardStaffFeatureShellRoutingModule {}
